import { render, staticRenderFns } from "./GeoJsonInfo.vue?vue&type=template&id=0bb9d443&scoped=true&"
import script from "./GeoJsonInfo.vue?vue&type=script&lang=js&"
export * from "./GeoJsonInfo.vue?vue&type=script&lang=js&"
import style0 from "./GeoJsonInfo.vue?vue&type=style&index=0&id=0bb9d443&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb9d443",
  null
  
)

export default component.exports